module.exports = __webpack_public_path__ + "images/choices/zhiren-31ba23e306e372a1f355911a1d9ec831.png";